import request from '@/service/api'
import ConfigType from '@/service/api/type'
import qs from 'qs'
// 订单件出入库API //
enum LocaltionApi {
    // 采购订单管理 //
    PO_PAGE = '/LESPurchaseOrder/page',//列表

    PO_PAGELIST = '/LESPurchaseOrder/pageList',//采购统计列表
    // 组盘入库
    GROUP_PAGE = '/GroupDiscWarehousing/Page',//主列表
    GROUP_METHORD_DETAILES = '/GroupDiscWarehousing/DetailPage',//组盘物料详情
    GROUP_METHORD_MATERIAL = '/GroupDiscWarehousing/MaterialPage',//组盘物料查询
    GROUP_GET_CONTAINER = '/GroupDiscWarehousing/GetContainer',//查询容器信息
    GROUP_METHORD_CONTAINER = '/GroupDiscWarehousing/GetBindContainer',//组盘获取容器信息
    GROUP_PAGE_CONTAINER = '/GroupDiscWarehousing/GroupContainer',//组盘操作
    GROUP_PAGE_EDIT = '/GroupDiscWarehousing/EditGroupContainer',//编辑
    GROUP_IN_CONTAINER = '/GroupDiscWarehousing/ManualIn',//手动入库
    GROUP_AUTO_CONTAINER = '/GroupDiscWarehousing/AutomaticIn',//自动入库    
    GROUP_METHORD_DELETE = '/GroupDiscWarehousing/Delete',//删除
    GROUP_METHORD_ENTRANCE = '/GroupDiscWarehousing/GetWarehouseEntrance',//入库口
    GROUP_METHORD_LOCAL = '/GroupDiscWarehousing/GetLocation',//库位编码
}
 // 采购订单管理
export const getPoPage = (data: any): ConfigType<any> => {
    return request({
        url: `${LocaltionApi.PO_PAGE}`,
        method: 'get',
        params: data
    })
}

 // 采购统计查询
 export const getPoPageList = (data: any): ConfigType<any> => {
    return request({
        url: `${LocaltionApi.PO_PAGELIST}`,
        method: 'get',
        params: data
    })
}

 // 组盘入库
 export const grouppage = (data: any): ConfigType<any> => {
    return request({
        url: `${LocaltionApi.GROUP_PAGE}?${qs.stringify(data)}`,
        method: 'get',
        params: data
    })
}
export const groupgetcontainer = (): ConfigType<any> => {
    return request({
        url: `${LocaltionApi.GROUP_GET_CONTAINER}`,
        method: 'get'
    })
}

export const containerdetail = (data: any): ConfigType<any> => {
    return request({
        url: `${LocaltionApi.GROUP_METHORD_DETAILES}?${qs.stringify(data)}`,
        method: 'get',
        params: data
    })
}

export const containerentrance = (data: any): ConfigType<any> => {
    return request({
        url: `${LocaltionApi.GROUP_METHORD_ENTRANCE}?${qs.stringify(data)}`,
        method: 'get',
        params: data
    })
}
export const localdetail = (data: any): ConfigType<any> => {
    return request({
        url: `${LocaltionApi.GROUP_METHORD_LOCAL}?${qs.stringify(data)}`,
        method: 'get',
        params: data
    })
}
export const containerdelete = (data: any): ConfigType<any> => {
    return request({
        url: LocaltionApi.GROUP_METHORD_DELETE,
        method: 'post',
        data
    })
}
export const grouppagecontainer = (data: any): ConfigType<any> => {
    return request({
        url: LocaltionApi.GROUP_PAGE_CONTAINER,
        method: 'post',
        data
    })
}
export const grouppageedit = (data: any): ConfigType<any> => {
    return request({
        url: LocaltionApi.GROUP_PAGE_EDIT,
        method: 'post',
        data
    })
}

export const groupincontainer = (data: any): ConfigType<any> => {
    return request({
        url: LocaltionApi.GROUP_IN_CONTAINER,
        method: 'post',
        data
    })
}
export const groupautocontainer = (data: any): ConfigType<any> => {
    return request({
        url: LocaltionApi.GROUP_AUTO_CONTAINER,
        method: 'post',
        data
    })
}
export const groupmethordcontainer = (data: any): ConfigType<any> => {
    return request({
        url: `${LocaltionApi.GROUP_METHORD_CONTAINER}`,
        method: 'get',
        params: data
    })
}
// 单据管理-手工入库-新增物料窗口中的物料表
export const getManualInventoryMaterialData = (data: any): ConfigType<any> => {
    return request({
        url: `${LocaltionApi.GROUP_METHORD_MATERIAL}?${qs.stringify(data)}`,
        method: 'get'
    })
}